export const MAX_SCREENSHOTS = 3;
export const MAX_REDIRECT_URIS = 5;

const BYTES_PER_MEGABYTE = 1024 * 1024;

export const LOGO_MAX_SIZE_BYTES = BYTES_PER_MEGABYTE;
export const SCREENSHOT_MAX_SIZE_BYTES = 2 * BYTES_PER_MEGABYTE;

export const LOGO_ACCEPTED_MIME_TYPES = [
  "image/jpeg",
  "image/png",
  "image/gif",
] as const;
export const SCREENSHOT_ACCEPTED_MIME_TYPES = [
  "image/jpeg",
  "image/png",
] as const;

const logoMimeTypes: ReadonlySet<string> = new Set(LOGO_ACCEPTED_MIME_TYPES);
const screenshotMimeTypes: ReadonlySet<string> = new Set(
  SCREENSHOT_ACCEPTED_MIME_TYPES,
);

type FileMetadata = Pick<File, "size" | "type">;

export const validateLogoFile = (file: FileMetadata): string | null => {
  if (!logoMimeTypes.has(file.type)) {
    return "You can only upload a JPG/PNG/GIF file.";
  }
  if (file.size > LOGO_MAX_SIZE_BYTES) {
    return "Image must be 1 MB or smaller.";
  }

  return null;
};

export const validateScreenshotFile = (file: FileMetadata): string | null => {
  if (!screenshotMimeTypes.has(file.type)) {
    return "You can only upload a JPG/PNG file.";
  }
  if (file.size > SCREENSHOT_MAX_SIZE_BYTES) {
    return "Image must be 2 MB or smaller.";
  }

  return null;
};

export const fileToDataUrl = (
  file: Blob,
  createReader: () => FileReader = () => new FileReader(),
): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = createReader();

    reader.onload = () => {
      if (typeof reader.result === "string") {
        resolve(reader.result);
        return;
      }

      reject(new Error("FileReader did not return a string data URL."));
    };
    reader.onerror = () => {
      reject(reader.error ?? new Error("Failed to read file."));
    };
    reader.readAsDataURL(file);
  });
